import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const SCInstructionContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding-top: 15vh;
  background-color: black;
`

interface SCInstructionBackgroundPortraitProps {
  $background: string;
}
export const SCInstructionBackgroundPortrait = styled.div<SCInstructionBackgroundPortraitProps>`
  position: absolute;
  top: ${pxToRem(40)};
  bottom: calc(${pxToRem(80)} + env(safe-area-inset-bottom, 0px));
  left: 0;
  right: 0;
  background-image: url(${({ $background }) => $background});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  z-index: 0;
  background-color: black;
  @media (min-width: 768px) and (orientation: landscape) {
    bottom: 0;
  }
`
